"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "getConcurrency", {
    enumerable: true,
    get: function() {
        return getConcurrency;
    }
});
const _os = /*#__PURE__*/ _interop_require_default(require("os"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function getConcurrency(optionsConcurrency, configConcurrency) {
    return optionsConcurrency || configConcurrency || _os.default.cpus().length - 1;
}
